import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { editUserStreamsSettings } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";

function UserStreamGeneral({
  register,
  errors,
  visibilityList,
  contactOrderList,
  isstreamsReq,
  watch,
  useragent,
  setIsloading,
  setValue,
  connectMeetingVisible,
  meetingroomenabled,
}) {
  const { t, i18n } = useTranslation();
  const [editConnectWarning, seteditConnectWarning] = useState(false);
  const connectWarningToggle = () => seteditConnectWarning(!editConnectWarning);
  const [warningMessage, setwarningMessage] = useState("");
  const streamsProductName = getStreamsProductName();
  async function handleConnectMeetingVisibility() {
    const update = {
      reqid: 51,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid: useragent,
      streams_general: {
        meeting_room_enabled: false,
        validate_connect_meeting: true,
      },
    };

    console.log(
      "modified data for streams genral :::" + JSON.stringify(update)
    );
    console.log(JSON.stringify(update));
    setIsloading(true);
    let saverep = await editUserStreamsSettings(update);
    console.log(`reponse of Edit user streams :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log("response of modified data :::" + JSON.stringify(saverepeMsg));
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    setValue("streams_general.meeting_room_enabled", false, {
      shouldDirty: true,
    });
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      const errorMessage = saverepeMsg.message;
      if (errorMessage && errorMessage !== "") {
        setwarningMessage(saverepeMsg.message);
        connectWarningToggle();
      }
    } else {
      // if (
      //   saverepeMsg.message?.errors &&
      //   saverepeMsg.message?.errors[0]?.errors
      // ) {
      // }
    }
  }

  return (
    <>
      <div className="general-settings" id="general2">
        {t("general")}
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("ContactVisbity")}</div>
        <div className="phoneselect w-30">
          <select
            className="form-control form-select selectname w-100"
            name="San Jose"
            {...register("streams_general.contact_visibility", {
              setValueAs: (value) => Number(value),
            })}
          >
            {Object.entries(visibilityList).map(([key, value]) => (
              <option value={key}>{value}</option>
            ))}
          </select>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("ContactNameOrder")}</div>
        <div className="phoneselect w-30">
          <select
            className="form-control form-select selectname w-100"
            name="San Jose"
            {...register("streams_general.contact_name_order", {
              setValueAs: (value) => Number(value),
            })}
          >
            {Object.entries(contactOrderList).map(([key, value]) => (
              <option value={key}>{value}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("DisplayContactExt")}</div>

        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              {...register("streams_general.display_contact_ext")}
              type="checkbox"
            />

            <span className="slider round"></span>
          </label>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("AllowUserdeletemessages")}</div>
        <div
          {...(isstreamsReq
            ? {
                title: "User does not have permission to edit",
                className: "disabled-form cursor-notAllowed",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
            : {})}
        >
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("streams_general.delete_msg")}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("ShowStreamsAnsPopUp", {"PRODUCT_NAME" : streamsProductName})}</div>

        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              {...register("streams_general.show_desktop_answer_pop_up")}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("ShowmultiloginPopUp")}</div>

        <div className="phoneselect">
          <label className="switch">
            <input
              disabled={!watch("multilogininfo.editflag")}
              className="form-control"
              type="checkbox"
              {...register("multilogininfo.loginflag")}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>
      {connectMeetingVisible && (
        <div
        {...(isstreamsReq
          ? {
              title: "User does not have permission to edit",
              className: "disabled-form cursor-notAllowed",
              onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
              },
            }
          : {})}
      >
        <div className="add-numbermain">
          <div className="tel-numbers">{t("ConnectMeetingRoomUser")}</div>

          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                checked={watch("streams_general.meeting_room_enabled")}
                onChange={(e) => {
                  e.preventDefault();
                  if (e.target.checked) {
                    setValue("streams_general.meeting_room_enabled", true, {
                      shouldDirty: true,
                    });
                  } else {
                    if (meetingroomenabled !== false) {
                      handleConnectMeetingVisibility();
                    } else {
                      setValue("streams_general.meeting_room_enabled", false, {
                        shouldDirty: true,
                      });
                    }
                  }
                }}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        </div>
      )}
      {editConnectWarning && (
        <PopupLoader
          size="md"
          className="modal-xl modal-auto"
          title="Warning"
          content={
            <>
              <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                <MDBIcon
                  fas
                  icon="exclamation-triangle"
                  className="me-3 fs-5 mt-1"
                  color="warning"
                />
                <div>{warningMessage}</div>
              </div>
              <MDBModalFooter>
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    setValue("streams_general.meeting_room_enabled", true, {
                      shouldDirty: true,
                    });
                    connectWarningToggle();
                  }}
                  color="secondary"
                >
                  {t("close")}
                </MDBBtn>
                <MDBBtn
                  onClick={(e) => {
                    e.preventDefault();
                    connectWarningToggle();
                  }}
                >
                  {t("ok")}
                </MDBBtn>
              </MDBModalFooter>
            </>
          }
          onShow={seteditConnectWarning}
          onClose={connectWarningToggle}
        />
      )}
    </>
  );
}

export default UserStreamGeneral;
